import { useEffect, useState } from 'react';
import {Route, BrowserRouter as Router,Routes} from 'react-router-dom';
import pathRoot from './services/pathRoot.jsx';
import api from './services/api.jsx';

import Header from './componentes/Header/header.jsx';
import Home from './componentes/Home/home.jsx';
import Empresa from './componentes/Empresa/empresa.jsx';
import Teste from './componentes/Teste/teste.jsx';
import Footer from './componentes/Footer/footer.jsx';
import MenuExtrato from './componentes/MenuExtrato/menuExtrato.jsx';
import NovoBoleto from './componentes/NovoBoleto/novoBoleto.jsx';
import RevisaoBoleto from './componentes/RevisaoBoleto/revisaoBoleto.jsx';
import Boleto from './componentes/Boleto/boleto.jsx';

function Rotas () {

    const [titulo, setTitulo] = useState("");
    const [slogan, setSlogan] = useState("");

    useEffect(() => {
        api.get("cadastro/empresas/1")    
            .then((resp) => {
                setTitulo(resp.data.NOME_FANTASIA+" - Taxa de custeio");

                api.get("administrativo/parametro?descricao=GERAL_SLOGANENTIDADE")
                    .then((res) => {
                        setSlogan(resp.data.NOME_FANTASIA+" - "+res.data.VALOR)
                    })
                    .catch((err) => {
                        if(err.response.data.RESULT){
                            alert(err.response.data.RESULT);
                        }else{
                            alert(err.response.data);
                        }      
                    });
            })
            .catch((err) => {
                if(err.response.data.RESULT){
                    alert(err.response.data.RESULT);
                }else{
                    alert(err.response.data);
                }
            });
    }, []);


    return (
        <Router>
            {
                (titulo)?(
                    <>
                        <Header title={titulo}/>
                        <div className="div-box" style={{height:'90vh'}}>
                            <Routes>
                                {/* <Route path={pathRoot} element={<Home slogan={slogan} />}/> */}
                                {/* <Route path="/empresa" element={<Empresa slogan={slogan} />} /> */}
                                <Route path={pathRoot} element={<Empresa slogan={slogan} />}/>
                                <Route path="/teste" element={<Teste slogan={slogan} />} />
                                <Route path="/menuextrato" element={<MenuExtrato />} />
                                <Route path="/novoboleto" element={<NovoBoleto />} />
                                <Route path="/revisaoboleto" element={<RevisaoBoleto />} />
                                <Route path="/boleto" element={<Boleto />} />
                            </Routes>
                        </div>
                        <Footer />
                    </>
                ): null
            }
        </Router>
    );
}

export default Rotas;